module.exports = __webpack_public_path__ + "img/hamilelik-dogum-sigortasi.169b37a8.png";